import { Component, Input } from '@angular/core'
import { EpicLink, EpicWithStatus } from '@modules/private/worklog/data/interfaces/epic.interface'
import { EpicCategory, EPIC_CATEGORIES, EPIC_STATUS_META } from '../../data/constants/roadmap.constants'

/**
 * Detalle de una épica, dentro del diálogo del page. Junta las dos caras que antes vivían en dos
 * tarjetas distintas (ADR-0040 · D13): la de dirección —qué aporta, elementos de valor, métricas,
 * estimación de mercado— y la de ejecución —avance real, duración, proyectos que toca—.
 */
@Component({
  selector: 'app-roadmap-epic-card',
  templateUrl: './roadmap-epic-card.component.html',
  styleUrls: ['./roadmap-epic-card.component.scss']
})
export class RoadmapEpicCardComponent {
  @Input() row: EpicWithStatus | null = null

  readonly EPIC_STATUS_META = EPIC_STATUS_META

  get category(): EpicCategory | null {
    return EPIC_CATEGORIES.find((c) => c.id === this.row?.epic.category) ?? null
  }

  get accent(): string {
    return this.category?.color ?? '#8B5CF6'
  }

  get progress(): number {
    const r = this.row
    return r && r.taskCount ? Math.round((r.doneCount / r.taskCount) * 100) : 0
  }

  /**
   * Duración legible del TRABAJO real, no de la envolvente (ADR-0048 · D3). La tarjeta declaraba
   * "6 semanas" en épicas que costaron cuatro días: medía de la primera tarea a la última, huecos
   * incluidos. Y por debajo de dos días va en horas, porque ahí cae la mayoría del trabajo.
   */
  get durationLabel(): string | null {
    const ms = this.row?.workedMs
    if (ms == null || ms < 0) return null
    if (ms < 3600000) return `${Math.max(Math.round(ms / 60000), 1)} min`
    if (ms < 2 * 86400000) {
      const h = Math.floor(ms / 3600000)
      return `${h} hora${h === 1 ? '' : 's'}`
    }
    const d = Math.round(ms / 86400000)
    if (d < 7) return `${d} día${d === 1 ? '' : 's'}`
    const weeks = Math.round(d / 7)
    return `${weeks} semana${weeks === 1 ? '' : 's'} (${d} días)`
  }

  linkIcon(link: EpicLink): string {
    switch (link.type) {
      case 'adr': return 'fa-solid fa-file-contract'
      case 'scope': return 'fa-solid fa-list-check'
      case 'prd': return 'fa-solid fa-file-lines'
      case 'commit': return 'fa-solid fa-code-commit'
      default: return 'fa-solid fa-book'
    }
  }
}
